import type { UserInfoFieldName } from "./useUserInfoEdits";

/** Shared by the sections and by the blocked-save focus jump, so the id focused is the id rendered. */
export const USER_INFO_FIELD_IDS: Record<UserInfoFieldName, string> = {
  title: "myinfo-title",
  firstName: "myinfo-first-name",
  lastName: "myinfo-last-name",
  company: "myinfo-company",
  email: "myinfo-public-email",
  email2: "myinfo-ddc-email",
  homePhone: "myinfo-home-phone",
  workPhone: "myinfo-work-phone",
  mobile: "myinfo-mobile-phone",
  fax: "myinfo-fax"
};
